import angular from 'angular';

import AdvancedRegistration from './advancedRegistration/';

import AddBankInfoController from './addBankInfo/addBankInfoController';
import TermsSignController from './termsSign/termsSignController';
import PCCController from './pcc/pccController';

import './territoryUpdate/territoryUpdate.scss'; // no controller
import './contractorCSLB/contractorCSLB.scss'; // no controller
import HISCodeOfConductController from './hisCodeOfConduct/hisCodeOfConduct';
import Accounts from '../../../accounts';

export default angular.module('app.notificationCenter.modal.templates', [AdvancedRegistration, Accounts])
    .controller('AddBankInfoController', AddBankInfoController)
    .controller('HISCodeOfConductController', HISCodeOfConductController)
    .controller('TermsSignController', TermsSignController)
    .controller('PCCController', PCCController)
    .run(($templateCache) => {
        $templateCache.put('app/notificationCenter/modal/templates/addBankInfo/addBankInfo.html', require('./addBankInfo/addBankInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/territoryUpdate/territoryUpdate.html', require('./territoryUpdate/territoryUpdate.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/territoryUpdate/territoryUpdateLAC.html', require('./territoryUpdate/territoryUpdateLAC.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/termsSign/termsSign.html', require('./termsSign/termsSign.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/hisCodeOfConduct/hisCodeOfConduct.html', require('./hisCodeOfConduct/hisCodeOfConduct.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/contractorCSLB/contractorCSLB.html', require('./contractorCSLB/contractorCSLB.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/pcc/pcc.html', require('./pcc/pcc.html')); // eslint-disable-line global-require        
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/index.js